import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {useMemo} from 'react'

import {TEST_IDS} from '../constants/test-ids'
import {CommentDivider} from './CommentDivider'
import styles from './CommentLoading.module.css'

type CommentLoadingProps = {
  inHighlightedTimeline?: boolean
}

export const CommentLoading = ({inHighlightedTimeline}: CommentLoadingProps) => {
  // eslint-disable-next-line react-hooks/purity
  const lineCount = useMemo(() => Math.floor(Math.random() * 5) + 1, [])

  const baseAvatarLoadingSx = {
    mt: 4,
  }

  const avatarLoadingSx = inHighlightedTimeline
    ? {...baseAvatarLoadingSx, display: ['none', 'none', 'flex', 'flex']}
    : baseAvatarLoadingSx

  return (
    <div className={styles.CommentLoadingContainer}>
      <LoadingSkeleton variant="elliptical" height="40px" width="40px" sx={avatarLoadingSx} />
      <div className={styles.CommentLoadingContentWrapper}>
        <CommentDivider />
        <div data-testid={TEST_IDS.commentSkeleton} className={styles.CommentLoadingCard}>
          <div className={styles.CommentLoadingHeader}>
            <LoadingSkeleton variant="rounded" height="sm" width="150px" />
          </div>
          <div className={styles.CommentLoadingContent}>
            {[...Array(lineCount)].map((_, index) => (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <LoadingSkeleton key={index} variant="rounded" height="sm" width="random" />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
